import React from 'react'
import PageImg from "../../assets/images/404.png";
export default function Notfound() {
  return (
    <div className="center-screen">
            <img className="animated fadeIn" src={PageImg}/>
    </div>
  )
}